const sliders = document.querySelectorAll('.hero-slider');

if (sliders.length > 0) {
  import('slick-carousel').then(({ default: slick }) => {
    sliders.foreach(slider => {
      slider.slick({
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        fadeSpeed: 1000,
      });
    });
  });
}
